export const IMAGE_TYPE = {
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  PNG: 'image/png',
  SVG: 'image/svg+xml',
  WEBP: 'image/webp',
  GIF: 'image/gif',
  BMP: 'image/x-ms-bmp',
  TIFF: 'image/tiff',
  AVIF: 'image/avif',
  PJPEG: 'image/pjpeg',
}

export const API_PATHS = {
  default: 'default',
  template: 'template',
  inspiration: 'inspiration',
  productCutout: 'productCutout',
  versionSerieImage: 'versionSerieImage',
  attachment: 'attachment',
  CSV_IMPORT_SKUS: 'csvImportSkus',
  promptImageInput: 'promptImageInput',
  task: 'task',
  DRAFT_CATALOG_FILES: 'draftCatalogFiles',
  TEMPLATE_ZIP: 'templateZip',
}

export const DEFAULT_ACCEPT = [IMAGE_TYPE.JPEG, IMAGE_TYPE.JPG, IMAGE_TYPE.PNG, IMAGE_TYPE.SVG]

export function acceptString(types) {
  return types.join(', ')
}
